import { IBaseModel, BaseModel } from "../base.model";

export interface IBMEditedViewModel extends IBaseModel {
  fk_block: number,
  fk_apartment?: number,
  date_start_building: string,
  date_end_building: string
}
export class BMEditedViewModel extends BaseModel implements IBMEditedViewModel {
  fk_block: number
  fk_apartment?: number
  date_start_building: string
  date_end_building: string
}



// WEBPACK FOOTER //
// ./src/models/bm/bm-edited.viewmodel.ts